import { createContext, useContext, useState, ReactNode } from "react";

// Definišemo tip za kontekst
interface TitleContextType {
  title: string;
  setTitle: (newTitle: string) => void;
  subtitle: string;
  setSubtitle: (newSubtitle: string) => void;
}

// Kreiramo kontekst sa podrazumevanim vrednostima
const TitleContext = createContext<TitleContextType | undefined>(undefined);

// Hook za korišćenje konteksta
export const useTitle = () => {
  const context = useContext(TitleContext);
  if (!context) {
    throw new Error("useTitle must be used within a TitleProvider");
  }
  return context;
};

// Provider komponenta
export const TitleProvider = ({ children }: { children: ReactNode }) => {
  const [title, setTitle] = useState("Svi proizvodi");
  const [subtitle, setSubtitle] = useState("Unesite čaroliju u Vaš život sa našim nakitom");

  return (
    <TitleContext.Provider value={{ title, setTitle, subtitle, setSubtitle }}>
      {children}
    </TitleContext.Provider>
  );
};

export default TitleContext;